class ReportHelper {
  defaultDisplayCols = ['VALUE', 'CURRENCY', 'RATE'];

  setParams (filters, component) {
    this.filters = filters;
    this.component = component
  }

  /**
   * Get config value and periodic config if provided
   * @param configKey
   * @param value
   * @param period
   * @returns {string}
   */
  getNameFromConfig (configKey, value, period = null) {
    if (period) {
      return this.component.ZPFormatHelper.getConfigValuePeriod(configKey, 'id', value, 'name', true, period)
    } else {
      return this.component.BasicHelper.getConfigValue(configKey, 'id', value, 'name', true);
    }
  }

  /**
   * Get code of config element by id
   * @param configEl
   * @param value
   * @returns {null|string}
   */
  getCodeFromConfig (configEl, value) {
    const el = this.component.config[configEl][value];
    if (el && el.code) {
      return el.code;
    }
    return el;
  }

  /**
   * Add total columns for period for eachmeasure type
   * @param tblFields
   * @param headerData
   * @param periodId
   * @param firstRow
   * @param firstPeriod
   * @param countPrecision
   * @returns {array}
   */
  addTotalColumns (tblFields, headerData, periodId, firstRow, firstPeriod, countPrecision) {
    let isStartOfGroup = true;
    for (const measureTypeId in firstRow.periods[periodId].total) {
      if (firstPeriod) {
        headerData.measureTypeCount++;
      }
      tblFields.push({
        key: 'periods.' + periodId + '.total.' + measureTypeId,
        label: this.getNameFromConfig('measure_types', measureTypeId),
        format: 'formatDecimal',
        precision: countPrecision,
        startOfGroup: isStartOfGroup,
        isTotalCol: true
      });
      isStartOfGroup = false;
    }
    return tblFields;
  }

  /**
   * Fill all calculated row column values to zero
   * @param el
   * @param elId
   * @param periodId
   * @param cols
   * @param totalCols
   * @param bool hasCosts
   */
  blankRowData (el, elId, periodId, cols, totalCols, hasCosts) {
    if (!Object.prototype.hasOwnProperty.call(el, elId)) {
      el[elId] = { cols: {}, total: {}, periods: {} };
      el[elId].periods[periodId] = { cols: {}, total: {} };
      if (hasCosts) {
        el[elId].cost = 0;
        el[elId].costFull = 0;
        el[elId].periods[periodId].cost = 0;
        el[elId].periods[periodId].costFull = 0;
      }
      for (const key in cols) {
        el[elId].cols[key] = 0;
        el[elId].periods[periodId].cols[key] = 0;
      }
      for (const key in totalCols) {
        el[elId].total[key] = 0;
        el[elId].periods[periodId].total[key] = 0;
      }
    }
  }

  /**
   *
   * @param oldValues
   * @param newValues
   * @returns {*}
   */
  overwriteRowValues (oldValues, newValues) {
    for (const [key, values] of Object.entries(newValues)) {
      oldValues[key] = values;
    }
    return oldValues;
  }

  /**
   * Increase total
   * @param el
   * @param periodId
   * @param measureTypeId
   * @param value
   * @returns {*}
   */
  sumInTotalForEl (el, periodId, measureTypeId, value) {
    el.totalAll += value;
    el.periods[periodId].total[measureTypeId] += value;
    el.total[measureTypeId] += value;

    return el;
  }

  /**
   * Increate total cost
   * @param el
   * @param periodId
   * @param cost
   * @param costFull
   * @returns {*}
   */
  addTotalCostForEl (el, periodId, cost, costFull) {
    el.periods[periodId].cost += cost;
    el.periods[periodId].costFull += costFull;
    el.cost += cost;
    el.costFull += costFull;

    return el;
  }

  /**
   * Recalculate sums (only 1 period). User in report form to auto update totals when editing values
   * @param reportData
   * @returns {*}
   */
  recalculateReportData (reportData) {
    const categoryValues = {};
    const groupValues = {};
    const periodId = reportData.header.periods[0];
    const self = this;

    reportData.data.forEach(function (row, rowId) {
      if (row.material) {
        let hasCosts = false;
        if (reportData.header.hasSummedColumns) {
          for (const key of Object.keys(reportData.data[rowId].total)) {
            reportData.data[rowId].total[key] = 0;
            reportData.data[rowId].periods[periodId].total[key] = 0;
            reportData.data[rowId].totalAll = 0;
          }
          if (Object.prototype.hasOwnProperty.call(reportData.data[rowId], 'cost')) {
            reportData.data[rowId].cost = 0;
            reportData.data[rowId].costFull = 0;
            reportData.data[rowId].periods[periodId].cost = 0;
            reportData.data[rowId].periods[periodId].costFull = 0;
            hasCosts = true;
          }
        }

        self.blankRowData(categoryValues, row.category, periodId, row.periods[periodId].cols, row.total, hasCosts);
        self.blankRowData(groupValues, row.group, periodId, row.periods[periodId].cols, row.total, hasCosts);

        for (const [key, strValue] of Object.entries(row.periods[periodId].cols)) {
          let value = parseFloat(strValue);
          if (isNaN(value)) {
            value = 0;
          }
          if (value < 0) {
            value = -value;
            reportData.data[rowId].periods[periodId].cols[key] = value;
          }
          if (row.multiaddData && row.multiaddData[key]) {
            value = 0;
            row.multiaddData[key].forEach(el => {
              if (el.weight) {
                value += parseFloat(el.weight);
              }
            });
            reportData.data[rowId].periods[periodId].cols[key] = value;
          }
          const field = reportData.fields.find(obj => { return (obj.typeId + '') === key });
          reportData.data[rowId].cols[key] = value;

          categoryValues[row.category].cols[key] += value;
          categoryValues[row.category].periods[periodId].cols[key] += value;
          groupValues[row.group].cols[key] += value;
          groupValues[row.group].periods[periodId].cols[key] += value;
          if (field.sumInTotal) {
            reportData.data[rowId] = self.sumInTotalForEl(reportData.data[rowId], periodId, field.measureTypeId, value);
            categoryValues[row.category] = self.sumInTotalForEl(categoryValues[row.category], periodId, field.measureTypeId, value);
            groupValues[row.group] = self.sumInTotalForEl(groupValues[row.group], periodId, field.measureTypeId, value);
          }
        }
        if (Object.prototype.hasOwnProperty.call(reportData.data[rowId], 'cost')) {
          const costFull = Math.round(100 * reportData.data[rowId].totalAll * row.rate) / 100;
          let cost = costFull;
          if (row.discount) {
            cost = Math.round(100 * reportData.data[rowId].totalAll * row.rate * (1 - row.discount)) / 100;
          }
          reportData.data[rowId] = self.addTotalCostForEl(reportData.data[rowId], periodId, cost, costFull);
          categoryValues[row.category] = self.addTotalCostForEl(categoryValues[row.category], periodId, cost, costFull);
          groupValues[row.group] = self.addTotalCostForEl(groupValues[row.group], periodId, cost, costFull);
        }
      } else if (row.category !== 'NONE' && row.category && categoryValues[row.category]) {
        reportData.data[rowId] = self.overwriteRowValues(reportData.data[rowId], categoryValues[row.category]);
      } else if (row.group && groupValues[row.group]) {
        reportData.data[rowId] = self.overwriteRowValues(reportData.data[rowId], groupValues[row.group]);
      }
    })

    return reportData;
  }

  /**
   * Generate report table data based on returned api data
   * @param array apiData
   * @param bool displayTotal
   * @param object extraConfig
   * @param number countPrecision
   * @param bool displayDiscountInfo
   * @param array displayCols
   * @param array summaryCols
   * @param bool displayBilled
   * @returns {[]}
   */
  createReportData (apiData, displayTotal, extraConfig = null, countPrecision = 2, displayDiscountInfo = true,
    displayCols = this.defaultDisplayCols, summaryCols = null, displayBilled = false
  ) {
    const displayTableData = [];
    if (summaryCols === null) {
      summaryCols = displayCols;
    }
    const hasTwoLevelCategories = true;
    for (const reportId in apiData) {
      const headerData = { periods: [], cols: [], measureTypeCount: 0, hasSummedColumns: false, displayCols: displayCols, summaryCols: summaryCols, multiaddRowspan: 1 };
      let tblFields = [];

      const firstRow = apiData[reportId][Object.keys(apiData[reportId])[0]];
      if (Object.prototype.hasOwnProperty.call(firstRow, 'material')) {
        tblFields.push({
          key: 'material',
          label: this.component.$t('material.title'),
          format: 'formatFromConfig',
          configKey: 'materials',
          configParam: 'name'
        });
      }
      if (displayCols.includes('RATE') && Object.prototype.hasOwnProperty.call(firstRow, 'rate')) {
        tblFields.push({
          key: 'rate',
          label: this.component.$t('material.rate'),
          format: 'formatDecimal',
          precision: 4
        });
        headerData.multiaddRowspan += 1;
        if (displayDiscountInfo) {
          tblFields.push({
            key: 'discount',
            label: this.component.$t('material.discount'),
            format: 'formatPercent',
            precision: 2
          });
          headerData.multiaddRowspan += 1;
        }
      }
      let typelist = Object.keys(firstRow.cols);
      if (extraConfig && extraConfig.colorder) {
        typelist = [];
        extraConfig.colorder.forEach(typeId => {
          if (firstRow.cols[typeId] !== undefined) {
            typelist.push(typeId);
          }
        });
      }

      let firstPeriod = true;
      if (firstRow.periods) {
        for (const periodId in firstRow.periods) {
          headerData.periods.push(periodId);
          if (Object.prototype.hasOwnProperty.call(firstRow, 'total')) {
            headerData.hasSummedColumns = true;
          }
          if (displayCols.includes('VALUE') && !Object.prototype.hasOwnProperty.call(firstRow, 'rate')) {
            tblFields = this.addTotalColumns(tblFields, headerData, periodId, firstRow, firstPeriod, countPrecision);
          } else if (firstPeriod && !displayCols.includes('VALUE') && !Object.prototype.hasOwnProperty.call(firstRow, 'rate')) {
            headerData.measureTypeCount = Object.keys(firstRow.periods[periodId].total).length;
          }
          if (displayCols.includes('VALUE')) {
            headerData.cols = typelist;
            typelist.forEach(typeId => {
              const colConfig = firstRow.columns[typeId];
              let measureTypeId = colConfig.measureTypeId;
              if (measureTypeId === null) {
                measureTypeId = firstRow.defaultMeasureTypeId;
              }
              tblFields.push({
                key: 'periods.' + periodId + '.cols.' + typeId,
                label: this.getNameFromConfig('report_column_types', typeId),
                format: 'formatDecimal',
                precision: countPrecision,
                isEditable: 1,
                typeId: typeId,
                periodId: periodId,
                sumInTotal: colConfig.sumInTotal,
                measureTypeId: measureTypeId
              });
              headerData.multiaddRowspan += 1;
            });
          } else {
            headerData.cols = [];
          }
          if (displayCols.includes('RATE') && Object.prototype.hasOwnProperty.call(firstRow, 'rate')) {
            tblFields = this.addTotalColumns(tblFields, headerData, periodId, firstRow, firstPeriod, countPrecision);
          }
          if (displayCols.includes('CURRENCY') && Object.prototype.hasOwnProperty.call(firstRow, 'cost')) {
            tblFields.push({ key: 'periods.' + periodId + '.cost', label: this.component.$t('general.currency'), format: 'formatDecimal', precision: 2, isTotalCol: true });
          }
          if (displayCols.includes('RATE') && Object.prototype.hasOwnProperty.call(firstRow.periods[periodId], 'costPer')) {
            for (const measureTypeId in firstRow.periods[periodId].costPer) {
              tblFields.push({
                key: 'periods.' + periodId + '.costPer.' + measureTypeId,
                label: this.component.$t('general.currency') + ' / ' + this.getNameFromConfig('measure_types', measureTypeId),
                format: 'formatDecimal',
                precision: 2,
                isTotalCol: true
              });
            }
          }
          firstPeriod = false;
        }
      }
      if (displayTotal) {
        let isStartOfGroup = true;
        if (displayCols.includes('VALUE')) {
          for (const measureTypeId in firstRow.total) {
            tblFields.push({
              key: 'total.' + measureTypeId,
              label: this.getNameFromConfig('measure_types', measureTypeId),
              format: 'formatDecimal',
              precision: countPrecision,
              startOfGroup: isStartOfGroup
            });
            isStartOfGroup = false;
          }
          typelist.forEach(typeId => {
            const elConfig = this.component.$store.getters.getDataFromConfigById('report_column_types', typeId);
            tblFields.push({
              key: 'cols.' + typeId,
              label: this.getNameFromConfig('report_column_types', typeId),
              format: 'formatDecimal',
              precision: countPrecision,
              measureTypeId: ((elConfig && elConfig.measure_type_id !== null) ? elConfig.measure_type_id : firstRow.defaultMeasureTypeId)
            });
          });
        }
        if (summaryCols.includes('CURRENCY') && Object.prototype.hasOwnProperty.call(firstRow, 'cost')) {
          tblFields.push({ key: 'cost', label: this.component.$t('general.currency'), format: 'formatDecimal', precision: 2 });
        }
        if (summaryCols.includes('RATE') && Object.prototype.hasOwnProperty.call(firstRow, 'costPer')) {
          for (const measureTypeId in firstRow.costPer) {
            tblFields.push({
              key: 'costPer.' + measureTypeId,
              label: this.component.$t('general.currency') + ' / ' + this.getNameFromConfig('measure_types', measureTypeId),
              format: 'formatDecimal',
              precision: 2
            });
          }
        }
      }

      if (displayBilled && Object.prototype.hasOwnProperty.call(firstRow, 'cost')) {
        tblFields.push({ key: 'billed.cost', label: this.component.$t('report.billed-cost'), format: 'formatDecimal', precision: 2, class: 'left-border' });
      }

      displayTableData.push({
        data: Array.from(apiData[reportId]),
        fields: tblFields,
        header: headerData,
        hasTwoLevelCategories: hasTwoLevelCategories
      });
    }
    return displayTableData;
  }

  /**
   * Create report data where each line is new period and has yearly totals
   * @param array apiData
   * @param number precision
   */
  createSummaryReport (apiData, precision = 0) {
    const displayTableData = [];
    for (const reportId in apiData) {
      const tblFields = [
        { key: 'periodId', label: this.component.$t('general.datePeriod.title'), format: 'formatDatePeriod', extraHeaders: [[]] }
      ];
      const tblItems = [];
      let maxPeriodId = null;
      if (apiData[reportId][0] && apiData[reportId][0].periods) {
        /**
         * Add each period as new row & add yearly summary row
         */
        let prevYear = null;
        for (const periodId in apiData[reportId][0].periods) {
          const perConf = this.component.BasicHelper.datePeriodCodeToData(periodId);
          if (perConf) {
            tblItems[periodId] = { periodId: periodId };
            if (prevYear !== null && prevYear !== perConf.year) {
              tblItems[this.component.BasicHelper.yearToDatePeriod(prevYear)] = { periodId: this.component.BasicHelper.yearToDatePeriod(prevYear) };
            }
            prevYear = perConf.year;
          }
          if (prevYear !== null) {
            tblItems[this.component.BasicHelper.yearToDatePeriod(prevYear)] = { periodId: this.component.BasicHelper.yearToDatePeriod(prevYear) };
          }
          maxPeriodId = periodId;
        }
      }
      const hasSingleCat = (apiData[reportId][apiData[reportId].length - 1].category !== null);
      let prevCat = null;
      let prevRow = null;
      let matDefaultMeasureType = null;
      let matCount = 0;
      const parentCategories = {};
      apiData[reportId].forEach(row => {
        /**
         * Add material, total columns as default columns and category names as extraHeaders
         */
        let elKey = row.category + '_total';
        let isGroupSummary = false;
        let colClass = 'left-border';
        const curCategory = this.component.$store.getters.getDataFromConfigById('material_categories', row.category);
        if (curCategory) {
          curCategory.id = row.category;
        }
        if (prevCat !== null && row.category !== prevCat.id) {
          if (tblFields[0].extraHeaders[0].length === 0) {
            tblFields[0].extraHeaders[0].push({});
          }
          let catEl = prevCat;
          let depth = 0;
          while (catEl) {
            if (!Object.prototype.hasOwnProperty.call(parentCategories, catEl.id)) {
              parentCategories[catEl.id] = { colspan: 0, depth: depth };
            }
            parentCategories[catEl.id].colspan += matCount;
            if (parentCategories[catEl.id].depth < depth) {
              parentCategories[catEl.id].depth = depth;
            }
            const elId = catEl.parent_category_id;
            catEl = this.component.$store.getters.getDataFromConfigById('material_categories', elId);
            if (catEl) {
              catEl.id = elId;
            }
            depth += 1;
          }

          if (matCount > 1) {
            tblFields[0].extraHeaders[0].push({ colspan: matCount, label: this.getNameFromConfig('material_categories', prevCat.id, maxPeriodId), class: 'left-border text-center' })
          } else {
            tblFields[0].extraHeaders[0].push({ colspan: 1, label: '', class: 'left-border text-center' });
          }
          /**
           * Add parent categories (includes leveling them
           */
          let el = null;
          if (prevRow.material === null && parentCategories[prevRow.category]) {
            el = parentCategories[prevRow.category];
          }
          if (el && el.depth > 0) {
            if (!Object.prototype.hasOwnProperty.call(tblFields[0].extraHeaders, el.depth)) {
              tblFields[0].extraHeaders[el.depth] = [{ colspan: (tblFields.length - el.colspan), label: '', class: 'left-border', rowLength: (tblFields.length - el.colspan) }];
            }
            if (tblFields[0].extraHeaders[el.depth][0].rowLength + el.colspan < tblFields.length) {
              tblFields[0].extraHeaders[el.depth].push({ colspan: (tblFields.length - el.colspan - tblFields[0].extraHeaders[el.depth][0].rowLength), label: '', class: 'left-border border-top-none' });
            }
            tblFields[0].extraHeaders[el.depth].push({ colspan: el.colspan, label: this.getNameFromConfig('material_categories', prevRow.category, maxPeriodId), class: 'left-border text-center' });
            tblFields[0].extraHeaders[el.depth][0].rowLength = tblFields.length;
          }
          matCount = 0;
        }
        if (prevCat !== null && row.category === prevCat.id) {
          colClass = '';
        }
        prevCat = curCategory;
        prevRow = row;
        matCount += 1;
        if (row.material) {
          elKey = row.category + '_' + row.material;
          tblFields.push({
            key: elKey,
            label: this.getNameFromConfig('materials', row.material, maxPeriodId),
            extraLabel: this.getNameFromConfig('measure_types', row.defaultMeasureTypeId),
            class: colClass + ' text-center sticky-header',
            format: 'formatDecimal',
            precision: precision
          });
          matDefaultMeasureType = row.defaultMeasureTypeId;
        } else if (row.category && !hasSingleCat) {
          if (row.defaultMeasureTypeId) {
            matDefaultMeasureType = row.defaultMeasureTypeId;
          }
          tblFields.push({
            key: elKey,
            label: this.component.$t('general.total'),
            extraLabel: this.getNameFromConfig('measure_types', matDefaultMeasureType),
            class: 'left-border text-center sticky-header',
            format: 'formatDecimal',
            precision: precision
          });
        } else {
          isGroupSummary = true;
          let colspan = 0;
          let isFirst = true;
          for (const measureTypeId in row.total) {
            tblFields.push({
              key: 'total.' + measureTypeId,
              format: 'formatDecimal',
              precision: precision,
              label: this.getNameFromConfig('measure_types', measureTypeId),
              class: (isFirst ? 'left-border' : '') + ' text-center sticky-header'
            });
            colspan += 1;
            isFirst = false;
          }
          if (Object.prototype.hasOwnProperty.call(row, 'cost')) {
            tblFields.push({
              key: 'cost',
              format: 'formatDecimal',
              precision: 2,
              label: this.component.$t('general.currency'),
              class: 'text-center sticky-header'
            });
            colspan += 1;
            for (const measureTypeId in row.costPer) {
              tblFields.push({
                key: 'costPer.' + measureTypeId,
                format: 'formatDecimal',
                precision: 4,
                label: this.component.$t('general.currency') + ' / ' + this.getNameFromConfig('measure_types', measureTypeId),
                class: 'text-center sticky-header'
              });
              colspan += 1;
            }
          }
          if (!hasSingleCat) {
            tblFields[0].extraHeaders[0].push({ colspan: colspan, label: this.component.$t('general.total'), class: 'left-border text-center' });
          }
        }
        /**
         * Add data for each period and year
         */
        ['periods', 'years'].forEach(itemKey => {
          for (const periodId in row[itemKey]) {
            let periodKey = periodId;
            if (itemKey === 'years') {
              periodKey = this.component.BasicHelper.yearToDatePeriod(periodId);
            }
            if (isGroupSummary === false) {
              if (
                Object.prototype.hasOwnProperty.call(row[itemKey][periodId], 'total') &&
                Object.prototype.hasOwnProperty.call(row[itemKey][periodId].total, matDefaultMeasureType)
              ) {
                tblItems[periodKey][elKey] = row[itemKey][periodId].total[matDefaultMeasureType];
              } else if (row[itemKey][periodId].cols) {
                const keys = Object.keys(row[itemKey][periodId].cols);
                if (keys.length > 0) {
                  tblItems[periodKey][elKey] = row[itemKey][periodId].cols[keys[0]];
                }
              }
            } else {
              tblItems[periodKey].total = row[itemKey][periodId].total;
              if (Object.prototype.hasOwnProperty.call(row, 'cost')) {
                tblItems[periodKey].cost = row[itemKey][periodId].cost;
                tblItems[periodKey].costPer = row[itemKey][periodId].costPer;
              }
            }
          }
        });
      });

      if (tblFields[0].extraHeaders.length > 1) {
        /**
         * Reorder extra headers to fix category tree
         */
        const newHeaders = [];
        let i = tblFields[0].extraHeaders.length - 1;
        while (i >= 0) {
          if (i > 0 && tblFields[0].extraHeaders[i][0].rowLength < tblFields.length) {
            tblFields[0].extraHeaders[i].push({ colspan: (tblFields.length - tblFields[0].extraHeaders[i][0].rowLength), label: '', class: 'left-border' })
          }
          newHeaders.push(tblFields[0].extraHeaders[i]);
          i -= 1;
        }
        tblFields[0].extraHeaders = newHeaders;
      }

      displayTableData.push({
        items: tblItems,
        fields: tblFields
      });
    }

    return displayTableData;
  }

  /**
   * Create POST data to be sent to API request
   * @param reportData
   * @param newStatus
   * @returns {{data: [], nextStatus: *}}
   */
  getReportPostData (reportData, newStatus) {
    const postData = [];
    const periodId = reportData.header.periods[0];
    const self = this;

    reportData.data.forEach(function (row, rowId) {
      if (row.material) {
        for (const [key, strValue] of Object.entries(row.periods[periodId].cols)) {
          const field = reportData.fields.find(obj => { return (obj.typeId + '') === key });
          if (field.isEditable) {
            let value = parseFloat(strValue);
            if (isNaN(value)) {
              value = 0;
            }
            if (value < 0) {
              value = -value;
            }
            postData.push({
              material: self.getCodeFromConfig('materials', row.material),
              type: self.getCodeFromConfig('report_column_types', key),
              value: value,
              multiadd: (row.multiaddData && row.multiaddData[key] ? row.multiaddData[key] : null)
            });
          }
        }
      }
    })

    return { data: postData, nextStatus: newStatus };
  }

  getReportStatusClass (reportData) {
    if (reportData && reportData.status_id) {
      const statusCode = this.component.$store.getters.getParamFromConfig('client_report_statuses', reportData.status_id, 'code');
      if (['DELETED', 'REJECTED'].includes(statusCode)) {
        return 'error';
      } else if (['APPROVED', 'BILL_CRT'].includes(statusCode)) {
        return 'text-success';
      }
    }
    return '';
  }
}

export default new ReportHelper()
